/**
 * @description MouseEvent button types
 * @see {@link https=//developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button}
 * @author Stan Gletski
 */
export enum MouseButton {

	/**
	 * @description Main button pressed, usually the left button or the un-initialized state
	 * @type {Number}
	 */
	MAIN = 0,

	/**
	 * @description Auxiliary button pressed, usually the wheel button or the middle button (if present)
	 * @type {Number}
	 */
	AUX = 1,

	/**
	 * @description Secondary button pressed, usually the right button
	 * @type {Number}
	 */
	SECONDARY = 2,

	/**
	 * @description Fifth button, typically the Browser Forward button
	 * @type {Number}
	 */
	FOURTH = 3,

	/**
	 * @description Fifth button, typically the Browser Forward button
	 * @type {Number}
	 */
	FIFTH = 4

}